export enum CashGroupIdEnum {
  PAYMENT = 1,
  DEPOSIT = 2,
  WITHDRAW = 3,
  COMMISSION = 4,
  FEE = 5,
}
